<template>
	<div>
		<el-table :data="teacher_list" border size="mini">
			<el-table-column prop="create_time" align="center" :label="$t('virtual.time')" data-nam="时间">
				<template slot-scope="scope"> {{getTime_us(scope.row.create_time,'mmddyyyy')}} {{getTime_us(scope.row.create_time,'hh:ii')}} </template>
			</el-table-column>
			<el-table-column prop="name" align="center" :label="$t('virtual.feedback_name')" data-name="用户"></el-table-column>
			<el-table-column prop="score" align="center" :label="$t('virtual.star')" data-name="星级"></el-table-column>
			<el-table-column prop="content" align="center" :label="$t('virtual.content')" data-name="内容"></el-table-column>
			<el-table-column prop="is_show" align="center" :label="$t('virtual.open')" data-name="状态" :formatter="open_f"></el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" v-if="scope.row.is_show!='1'" @click="userCourseAssessAction(scope.row,'1')" data-name="公开">{{$t('virtual.open')}}</el-button>
					<el-button size="mini" type="primary" v-if="scope.row.is_show!='2'" @click="userCourseAssessAction(scope.row,'2')" data-name="不公开">{{$t('virtual.on_open')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
		</div>
	</div>
</template>
<script>
export default {
	computed: {
		editFormRules() {
			return {
				reply: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('virtual.reply'),
					trigger: 'change'
				}],
			}
		},
	},
	props:{
		type: {
			type: String,
			default:''
		},
		course_id: {
			type: String,
			default:''
		},
		course_type: {
			type: String,
			default:''
		},
	},
	data() {
		return {
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			teacher_list:[],
			this_:this,
			open:[
				// {
				// 	en:'NO',
				// 	cn:'否',
				// 	id:0,
				// },
				{
					en:'YES',
					cn:'是',
					id:1,
				},
				{
					en:'NO',
					cn:'否',
					id:2,
				}
			]
		}
	},
	watch: {
		type(v){
			if (v=='comment') {
				this.init();
			}
		},
	},
	// 初始事件
	mounted: function () {
	},
	// 事件
	methods: {
		init(){
			var this_ = this;
			var url = "userCourseAssessList";
			var datas = {
				course_id:this_.course_id,
				course_type: this_.course_type,
				page: this_.pages.page,
				num: this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.teacher_list = res.list;
				this_.pages.count = res.sum;
			})
		},
		userCourseAssessAction(data,is_show){
			var this_ = this;
			var url = "userCourseAssessAction";
			var datas = {
				id:data.id,
				is_show:is_show
			};
			this_.$post(url, datas).then((res) => {
				this_.$message.success(this_.$t('index.operation_success'));
				this_.init();
			})
		},
		huife_f(data){
			this.editForm=JSON.parse(JSON.stringify(data));
			this.huife=true;	
		},
		open_f(w,s,d){
			var this_=this;
			var open=this.open;
			var name='';
			open.forEach(function(e,i) {
				if (e.id==d) {
					name= this_.lang=='cn'?e.cn:e.en;
				}
			});
			return name;
		},
		guanbi(){
			this.$emit("guanbitanchu");
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.page-pagination{
	padding: 20px 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/evaluate.vue